
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class PickUpBOMGrid extends Serenity.EntityGrid<PickUpBOMRow, any> {
        protected getColumnsKey() { return 'ECommerce.PickUpBOM'; }
        protected getDialogType() { return PickUpBOMDialog; }
        protected getIdProperty() { return PickUpBOMRow.idProperty; }
        protected getInsertPermission() { return PickUpBOMRow.insertPermission; }
        protected getLocalTextPrefix() { return PickUpBOMRow.localTextPrefix; }
        protected getService() { return PickUpBOMService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}